// ios-shell.ts — adaptations for when the studio web app is rendered inside
// the native Studio iOS shell (a WKWebView with customUserAgent set to
// "... StudioApp/1.0"). All adaptations are gated on the UA so normal
// Safari / desktop browsing is unaffected.
//
// Two things:
//   1. Add `<html class="in-ios-shell">` so CSS can target safe-area insets
//      only inside the shell (Safari already handles the status bar).
//   2. Hijack clicks on `/time` links and navigate to the `studio-timer://timer/open`
//      URL scheme; the iOS shell intercepts that and opens the native Timer
//      modal instead of letting the WebView load the web /time page.

const IOS_SHELL_UA_MARKER = /StudioApp\//;

function isInIOSShell(): boolean {
  return IOS_SHELL_UA_MARKER.test(navigator.userAgent);
}

function tagDocument(): void {
  document.documentElement.classList.add("in-ios-shell");
}

function interceptTimeLinks(): void {
  // Capture phase so we run BEFORE HTMX's click handler (which would
  // otherwise turn the link into an XHR via hx-boost). Once the URL
  // scheme is set as window.location, the WebView's navigation delegate
  // sees it and opens the native Timer modal.
  document.addEventListener(
    "click",
    (e) => {
      const target = e.target as Element | null;
      if (!target) return;
      const a = target.closest("a") as HTMLAnchorElement | null;
      if (!a) return;
      // Match same-origin /time and /time/* (but not /time-something-else).
      // a.pathname normalises this regardless of how the href was written.
      const path = a.pathname;
      if (path !== "/time" && !path.startsWith("/time/")) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = "studio-timer://timer/open";
    },
    true,
  );
}

if (isInIOSShell()) {
  tagDocument();
  interceptTimeLinks();
}
